import { render } from "./Tabs.vue?vue&type=template&id=afc597e6&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=afc597e6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-afc597e6"

export default script